/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const move_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23.25 9.747h-10.5A3.75 3.75 0 0 0 9 13.497m14.25-3.75-3-3m3 3-3 3m-3-7.5a1.5 1.5 0 0 0-1.5-1.5H2.25a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-4.5"
    />
  </svg>
)
export default move_medium
